import React from 'react';
import { Input } from 'semantic-ui-react';

interface DatePickerProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  min?: string;
  max?: string;
  name?: string;
  id?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

const DatePicker: React.FC<DatePickerProps> = ({
  value,
  onChange,
  placeholder = 'Select date',
  min,
  max,
  name,
  id,
  required = false,
  disabled = false,
  className = ''
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <Input
      type="date"
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      min={min}
      max={max}
      name={name}
      id={id}
      required={required}
      disabled={disabled}
      className={`table-input date-picker-input ${className}`.trim()}
      size="small"
    />
  );
};

export default DatePicker;
